import { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { getTimeZones } from "@vvo/tzdb";

dayjs.extend(utc);
dayjs.extend(timezone);

const timeZones = getTimeZones();

export const useGetAllTimeZones = () => {
  const [currentMinute, setCurrentMinute] = useState(dayjs().format("HH:mm"));

  useEffect(() => {
    const interval = setInterval(() => {
      const now = dayjs().format("HH:mm");
      if (now !== currentMinute) {
        setCurrentMinute(now);
      }
    }, 1000); // Check every second to be accurate
    return () => clearInterval(interval);
  }, [currentMinute]);

  const timeZonesArr = useMemo(() => {
    const now = dayjs();
    const arr = [];
    for (const tz of timeZones) {
      const [continent] = tz.name.split("/");
      if (!continent) continue;

      let time;
      try {
        time = now.tz(tz.name).format("h:mma");
      } catch {
        time = "";
      }

      const city = tz.mainCities[0];
      const country = tz.countryName;
      const name = `${city}, ${country} - ${time}`;
      arr.push({ id: tz.name, name });
    }
    return arr;
    // eslint-disable-next-line
  }, [currentMinute]);

  return { data: timeZonesArr, isSuccess: true, isLoading: false, isError: false };
};
